/* eslint-disable */
// src/layouts/localMachine/allVisitTransactionByLocal.js

import React, { useEffect, useMemo, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import LocalService from "services/localService";
import { Box, Button, TextField } from "@mui/material";
import Card from "@mui/material/Card";
import AppSnackbar from "components/common/AppSnackbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import VisitTransactionService from "services/visitTransactionService";
import VisitTransactionsView from "components/VisitTransactionDetails/visitTransactionsView";
import { filterApplyButtonSx, filterClearButtonSx } from "components/common/buttonStyles";

const defaultFilters = {
  from: "",
  to: "",
};

const defaultPagination = {
  page: 1,
  pageSize: 10,
  totalRows: 0,
  totalPages: 0,
  hasNextPage: false,
  hasPreviousPage: false,
};

export default function AllVisitTransactionByLocal() {
  const navigate = useNavigate();
  const location = useLocation();
  const initialViewState = location.state?.viewState || {};
  const { id } = useParams();
  const localId = Number(id);
  const localFromState = location.state?.local || null;
  const [local, setLocal] = useState(localFromState);
  const effectiveLocalId = Number(local?.Id ?? location.state?.localId ?? id);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snack, setSnack] = useState({ open: false, message: "", severity: "warning" });

  const restoredFilters = useMemo(
    () => ({
      from: initialViewState.filters?.from || "",
      to: initialViewState.filters?.to || "",
    }),
    [initialViewState.filters?.from, initialViewState.filters?.to]
  );

  const [sortBy] = useState("date");
  const [filters, setFilters] = useState(restoredFilters);
  const [appliedFilters, setAppliedFilters] = useState(restoredFilters);
  const [page, setPage] = useState(initialViewState.page || 1);
  const [pageSize, setPageSize] = useState(initialViewState.pageSize || 10);
  const [pagination, setPagination] = useState({
    ...defaultPagination,
    page: initialViewState.page || 1,
    pageSize: initialViewState.pageSize || 10,
  });
  const handleBackToLocal = () => {
    if (!Number.isFinite(effectiveLocalId)) {
      navigate("/local");
      return;
    }
    navigate(`/local/${effectiveLocalId}`, { state: { local } });
  };

  const localName = local?.Name || "Local";
  const pageTitle = `Ingresos de ${localName}`;
  const hasAppliedDateFilters = Boolean(appliedFilters.from || appliedFilters.to);
  const hasDraftDateFilters = Boolean(filters.from || filters.to);
  const filtersChanged =
    filters.from !== appliedFilters.from ||
    filters.to !== appliedFilters.to;
  const shouldShowClearFilters = hasAppliedDateFilters && !filtersChanged;
  const filtersButtonLabel = shouldShowClearFilters ? "Limpiar filtros" : "Aplicar filtros";
  const isFiltersButtonDisabled = !shouldShowClearFilters && !hasDraftDateFilters;
  const emptyMessage = hasAppliedDateFilters
    ? "No hay ingresos en el rango seleccionado."
    : "No hay ingresos en este local.";

  useEffect(() => {
    if (localFromState) setLocal(localFromState);
  }, [localFromState]);

  useEffect(() => {
    if (local) return;
    if (!Number.isFinite(localId)) return;

    (async () => {
      try {
        const fetched = await LocalService.getLocalWithOwnerById(localId);
        setLocal(fetched || null);
      } catch (e) {
        console.error("Error cargando local:", e);
      }
    })();
  }, [local, localId]);

  useEffect(() => {
    const viewState = location.state?.viewState;
    if (!viewState) return;
    setFilters({
      from: viewState.filters?.from || "",
      to: viewState.filters?.to || "",
    });
    setAppliedFilters({
      from: viewState.filters?.from || "",
      to: viewState.filters?.to || "",
    });
    setPage(viewState.page || 1);
    setPageSize(viewState.pageSize || 10);
  }, [location.key, location.state]);

  useEffect(() => {
    const fetchData = async () => {
      if (!Number.isFinite(localId)) return;
      setLoading(true);
      try {
        const data = await VisitTransactionService.getAllVisitTransactionByLocal(localId, {
          sortBy: "date",
          sortDir: "DESC",
          from: appliedFilters.from || undefined,
          to: appliedFilters.to || undefined,
          page,
          pageSize,
        });
        setRows(Array.isArray(data?.rows) ? data.rows : []);
        setPagination(data?.pagination || { ...defaultPagination, page, pageSize });
      } catch (err) {
        console.error(err);
        setRows([]);
        setPagination({ ...defaultPagination, page, pageSize });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [localId, appliedFilters.from, appliedFilters.to, page, pageSize]);

  const handleFilterChange = (field) => (event) => {
    const nextValue = event.target.value;
    setFilters((prev) => ({
      ...prev,
      [field]: nextValue,
    }));
  };

  const handleApplyFilters = () => {
    if (filters.from && filters.to && filters.from > filters.to) {
      setSnack({
        open: true,
        message: "La fecha Desde no puede ser mayor que Hasta.",
        severity: "warning",
      });
      return;
    }

    setAppliedFilters({
      from: filters.from || "",
      to: filters.to || "",
    });
    setPage(1);
  };

  const handleClearFilters = () => {
    setFilters(defaultFilters);
    setAppliedFilters(defaultFilters);
    setPage(1);
  };

  const handlePageChange = (nextPage) => {
    if (!Number.isInteger(nextPage) || nextPage < 1) return;
    setPage(nextPage);
  };

  const handlePageSizeChange = (nextPageSize) => {
    setPageSize(nextPageSize);
    setPage(1);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <MDTypography variant="h6" color="white">
              {pageTitle}
            </MDTypography>

            <Box sx={{ display: "flex", gap: 1 }}>
              <Button color="inherit" onClick={handleBackToLocal}>
                Volver al local
              </Button>
            </Box>
          </MDBox>

          <MDBox pt={3} px={2} pb={2}>
            <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 2,
                  p: 2,
                  mb: 2,
                  border: "1px solid rgba(0,0,0,0.08)",
                  borderRadius: "12px",
                  backgroundColor: "#fff",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    flexWrap: "wrap",
                    gap: 2,
                    flex: "1 1 auto",
                    minWidth: 0,
                  }}
                >
                  <TextField
                    label="Desde"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={filters.from}
                    onChange={handleFilterChange("from")}
                    sx={{ minWidth: { xs: "100%", sm: 170 }, flex: { xs: "1 1 100%", sm: "0 0 auto" } }}
                  />
                  <TextField
                    label="Hasta"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={filters.to}
                    onChange={handleFilterChange("to")}
                    sx={{ minWidth: { xs: "100%", sm: 170 }, flex: { xs: "1 1 100%", sm: "0 0 auto" } }}
                  />
                </Box>

                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, flex: { xs: "1 1 100%", md: "0 0 auto" } }}>
                  <Button
                    variant={shouldShowClearFilters ? "outlined" : "contained"}
                    color="info"
                    disabled={isFiltersButtonDisabled}
                    sx={shouldShowClearFilters ? filterClearButtonSx : filterApplyButtonSx}
                    onClick={shouldShowClearFilters ? handleClearFilters : handleApplyFilters}
                  >
                    {filtersButtonLabel}
                  </Button>
                </Box>
            </Box>

            <VisitTransactionsView
              rows={rows}
              loading={loading}
              showTitle={false}
              counterNoun="resultados"
              returnToLabel="Volver a ingresos"
              emptyMessage={emptyMessage}
              sortBy="date"
              sortDir="DESC"
              onSortByChange={() => {}}
              onSortDirChange={() => {}}
              query=""
              onQueryChange={() => {}}
              filters={appliedFilters}
              page={page}
              pageSize={pageSize}
              pagination={pagination}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
              searchText=""
              onSearchTextChange={() => {}}
              appliedQuery=""
              serverSide={true}
              showSearch={false}
              showSortControls={false}
              showLocalColumn={false}
              sortOptions={[{ value: "date", label: "Fecha" }]}
            />
          </MDBox>
        </Card>
      </MDBox>
      <Footer />
      <AppSnackbar
        open={snack.open}
        onClose={() => setSnack((prev) => ({ ...prev, open: false }))}
        severity={snack.severity}
        message={snack.message}
      />
    </DashboardLayout>
  );
}
